import React from 'react';
import { Section, Kicker } from './Section';
export function FreezeMoment() {
  return <Section background="white" width="narrow" labelledBy="freeze-heading" data-id="element-157" data-mp="3gu1t0697xhg">
      <div className="text-center" data-id="element-158" data-mp="3dy15430uupb">
        <Kicker data-id="element-159" data-mp="3lmoub8fnz0x2">The moment this system was built for</Kicker>

        <h2 id="freeze-heading" className="mt-6 font-serif text-[30px] font-semibold leading-[1.1] text-ink sm:text-4xl lg:text-5xl" data-id="element-160" data-mp="3pnije54uelrj">
          Forty seconds before class.
        </h2>

        <p className="mt-7 font-sans text-[17px] leading-[1.65] text-ink-soft sm:text-lg" data-id="element-161" data-mp="3gmkfdmueme8y">
          A student unrolls her mat, catches your eye and says — lightly, on her way past — "just so
          you know, I have a herniated disc." You didn't ask. She told you anyway. Twenty people are
          settling in, and the class you planned is now a decision you have eight seconds to make.
        </p>

        <p className="mt-9 font-serif text-2xl font-medium italic leading-snug text-brass sm:text-[28px]" data-id="element-162" data-mp="2xwukkzqn5sh1">
          You don't need to know more. You need something to say.
        </p>
      </div>
    </Section>;
}